const toArray = (value) => {
    if (Array.isArray(value)) return value;
    if (value && typeof value === "object") return Object.values(value);
    return [];
};

const toNumber = (value) => {
    const number = Number(value);
    return Number.isFinite(number) ? number : 0;
};

const crearSeccion = (nombre, items, total) => {
    const rows = items.map((item) => {
        const cantidad = item.cantidad == null ? 1 : toNumber(item.cantidad);
        const costoUnitario = toNumber(item.costo);

        return {
            nombre: item.nombre || "Ítem sin nombre",
            cantidad,
            costoUnitario,
            subtotal: cantidad * costoUnitario,
        };
    });

    return {
        nombre,
        items: rows,
        total: total == null
            ? rows.reduce((sum, item) => sum + item.subtotal, 0)
            : toNumber(total),
    };
};

export const buildProductCostSections = (producto) => {
    const sections = [];
    const itemsGenerales = toArray(producto?.items);

    if (itemsGenerales.length > 0) {
        sections.push(crearSeccion("Ítems del producto", itemsGenerales));
    }

    [producto?.gabinete, producto?.puerta, ...toArray(producto?.componentes)]
        .filter(Boolean)
        .forEach((componente) => {
            const items = toArray(componente.items);
            const costoDirecto = componente.costoTotal ?? componente.costo ?? 0;
            const detalle = items.length > 0
                ? items
                : [{ nombre: "Costo del componente", cantidad: 1, costo: costoDirecto }];

            sections.push(crearSeccion(
                componente.nombre || componente.type || componente.tipo || "Componente",
                detalle,
                componente.costoTotal ?? (items.length > 0 ? undefined : costoDirecto)
            ));
        });

    const servicios = toArray(producto?.servicios);
    if (servicios.length > 0) {
        sections.push(crearSeccion(
            "Servicios tercerizados",
            servicios.map((servicio) => ({
                nombre: [servicio.nombre, servicio.descripcion].filter(Boolean).join(" — ")
                    || "Servicio sin nombre",
                cantidad: 1,
                costo: servicio.costo,
            }))
        ));
    }

    return sections;
};
